var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Camera_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camera_",
    "data-name": "Camera ",
    clipPath: "url(#clip-Camera_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(0 -0.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M412.562,5.077c-10.177-.852-20.326,2.165-29.235,8.692l-219.9,167.163c-11.724,8.879-20.274,23.537-23.757,40.73a85.565,85.565,0,0,0,5.2,50.875L183,359.128c13.969,32.037,45.042,43.113,69.4,24.74l45.759-33.433c6.915,14.942,17.233,26.639,29.489,33.432v57.838c0,36.929,22.763,66.865,50.844,66.865H510.436V441.706H378.5V383.868c16.741-9.271,29.647-27.553,35.435-50.2s3.9-47.467-5.183-68.154l64.317-48.812c11.767-8.823,20.371-23.456,23.9-40.654a85.6,85.6,0,0,0-5.091-50.951L453.745,38.51C445.337,19.22,430.187,6.69,413.325,5.077M109.28,280.227,2,303.63l19.066,43.462L71.91,462.769l19.066,43.462L160.124,395.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 512,
    height: 512,
    transform: "translate(0 0.065)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.22375b57bc506227141c66ff69b7c4f1.svg";
export { ForwardRef as ReactComponent };